/**
 * SHER-130: build the "Created by" label for a clinical-history submission —
 * the author's name plus their department.
 *
 * The department is taken from the author's OWN department(s) for the
 * investigation, delivered by the API on `researcher.department`
 * (Researcher -> ResearcherInvestigation -> units -> department). At CHOM /
 * Cardio24 the submission's survey has no unit, so the old survey-unit lookup
 * (`uuidUnit`) always resolved to nothing and the department never showed —
 * and it still appended a dangling " - " with an empty department. This helper
 * prefers `researcher.department`, keeps the legacy survey-unit lookup as a
 * fallback (for investigations that DO scope surveys to a unit), and — the
 * fix — omits the separator entirely when there is no department.
 */
export interface SubmissionAuthorResearcher {
    name: string;
    surnames: string;
    department?: string | null;
}

interface UnitLite {
    uuid: string;
    name: string;
}

interface DepartmentLite {
    name: string;
    units: UnitLite[];
}

export function buildSubmissionAuthorLabel(
    researcher: SubmissionAuthorResearcher,
    uuidUnit: string | null | undefined,
    departments: DepartmentLite[] | null | undefined,
): string {
    const fullName = `${researcher.name} ${researcher.surnames}`.trim();

    let departmentString = "";
    if (researcher.department) {
        departmentString = researcher.department;
    } else if (uuidUnit) {
        let department: DepartmentLite | null = null;
        let unit: UnitLite | null = null;
        (departments || []).forEach((departmentSur) => {
            departmentSur.units.forEach((unitDe) => {
                if (unitDe.uuid === uuidUnit) {
                    unit = unitDe;
                    department = departmentSur;
                }
            });
        });
        departmentString = department && unit ? `${department.name}: ${unit.name}` : "Department deleted";
    }

    return departmentString ? `${fullName} - ${departmentString}` : fullName;
}
